module.exports = __webpack_public_path__ + "static/img/eec-group1.98f0ca62.png";